<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="showForm(null)"
          >新增成品油类型</el-button
        >
      </template>
      <el-form
        :model="searchForm"
        ref="formData"
        inline
        class="global-form-label-width account-form"
        label-width="100px"
      >
        <el-form-item label="类型名称" prop="oilTypeName">
          <el-input
            clearable
            v-model="searchForm.oilTypeName"
            placeholder="类型名称"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column
          min-width="120"
          label="类型名称"
          prop="oilTypeName"
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="规格"
          prop="oilSpecs"
        ></el-table-column>

        <el-table-column
          min-width="120"
          label="单位"
          prop="ygUnitName"
        ></el-table-column>
        <el-table-column min-width="120" label="图片" prop="oilImg">
          <template v-slot="{ row }">
            <el-image
              v-if="row.oilImg"
              style="width: 60px; height: 60px"
              :src="row.oilImg"
              :preview-src-list="[row.oilImg]"
            >
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column width="250" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button
              type="text"
              @click="$router.push('/cpyCategory/edit?oilType=' + row.oilType)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="
                $router.push('/cpyCategory/detail?oilType=' + row.oilType)
              "
              >详情</el-button
            >

            <el-button
              type="text"
              @click="deleteRow(row.oilType)"
              class="del-btn"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mt15"
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'cpyCategoryList',
  data () {
    return {
      activeType: '1',
      tableData: [],
      roles: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        oilTypeName: ''
      },
      dialogVisible: false,
      cpyTypeList: []
    }
  },
  created () {
    this.loadData()
  },
  computed: {

  },
  methods: {

    getCpyTypeList () {
      this.$axios.get(this.$apis.oiltabkManage.selectYgOilTypeByPage, {
        page: 1,
        size: 999
      }).then(res => {
        this.cpyTypeList = res.list
      })
    },
    closeCascader () {
      this.$refs.cascader.dropDownVisible = false
    },
    loadData () {
      const params = {
        page: this.page,
        oilTypeName: this.searchForm.oilTypeName

      }
      this.$axios.get(this.$apis.oiltabkManage.selectYgOilTypeByPage, {
        params: params
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    onReset () {
      this.$refs.formData.resetFields()
    },
    showForm () {
      this.$router.push('/cpyCategory/add')
    },

    deleteRow (oilType) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.oiltabkManage.deleteDataYgOilType, {
          oilType
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }
</style>
<style lang='scss'>
.account-form {
  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
